import { FC } from 'react';
import { useRouter } from 'next/router';
import { BreadCrumb } from '@/components/atoms';
import { IBreadCrumb } from '@/components/atoms/BreadCrumb/IBreadCrumbCmp';
import { getLabel } from '@/utils/index';
import { ICollectionBreadcrumb } from './ICollectionBreadcrumbCmp';
import { useTranslation } from 'next-i18next';

const CollectionBreadcrumb: FC<ICollectionBreadcrumb> = ({
  collectionTags,
}) => {
  const { t } = useTranslation(['common']);
  const router = useRouter();
  const { pathname } = router;

  let { slug, ...queryParameters } = router.query;
  if (slug && !Array.isArray(slug)) {
    slug = [slug];
  }

  let collectionBasePath = pathname.slice(1);

  if (collectionBasePath.indexOf('/') !== -1) {
    collectionBasePath = collectionBasePath.substring(
      0,
      collectionBasePath.indexOf('/')
    );
  }

  let breadcrumbTokens: IBreadCrumb['tokens'] = [];

  if (pathname) {
    breadcrumbTokens.push({
      label: t('common:all'),
      href: {
        pathname,
        query: { slug: [], ...queryParameters },
      },
    });

    if (slug && slug.length > 0) {
      for (const [index, _slug] of (slug as string[]).entries()) {
        const label = getLabel(
          _slug,
          collectionTags.categories[_slug] ||
            collectionTags.filters['gender'] ||
            null
        );
        let categoriesPath = (slug as string[]).slice(0, index + 1);

        breadcrumbTokens.push({
          label: label,
          href: {
            pathname,
            query: { slug: categoriesPath, ...queryParameters },
          },
        });
      }
    }
  }

  return (
    <>
      {breadcrumbTokens.length > 0 && (
        <BreadCrumb tokens={breadcrumbTokens} homeIcon={false} size="small" />
      )}
    </>
  );
};

export default CollectionBreadcrumb;
